var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1294 13.1053H0.5V15H15.5V13.1053H12.7215L12.0508 10.6851C11.9922 10.7163 11.9279 10.7402 11.8592 10.754C10.5887 11.018 9.27479 11.1536 7.92547 11.1536C6.57542 11.1536 5.20297 11.0107 3.90424 10.7395C3.86658 10.7316 3.8296 10.7207 3.79367 10.7069L3.1294 13.1053ZM4.19911 9.31944L4.1796 9.31581L4.95653 6.50906C5.93442 6.70273 6.92871 6.80085 7.92547 6.80207C8.85221 6.80351 9.7771 6.71927 10.6884 6.5504C10.7576 6.5375 10.8246 6.51453 10.8872 6.48223L11.6728 9.31944C11.6368 9.32134 11.6011 9.32594 11.5658 9.33322C10.3936 9.57763 9.17795 9.7031 7.92547 9.7031C6.67371 9.7031 5.401 9.57038 4.19911 9.31944ZM7.92547 5.35155C7.05979 5.35096 6.19603 5.26962 5.34535 5.10859L6.36439 1.4279C6.43666 1.17406 6.66071 1 6.92089 1H8.93005C9.05668 1.00043 9.17968 1.04251 9.28019 1.1198C9.3807 1.19709 9.45319 1.30532 9.48655 1.4279L10.5078 5.11366C10.4796 5.11584 10.4521 5.11947 10.4239 5.12454C9.61664 5.2754 8.779 5.35155 7.92547 5.35155Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConeFill);
export default __webpack_public_path__ + "static/media/icon-cone-fill.530de27f68a4542badcc8bfa5623713e.svg";
export { ForwardRef as ReactComponent };